import { render, staticRenderFns } from "./Reminder2fa.vue?vue&type=template&id=560e4a55&"
import script from "./Reminder2fa.vue?vue&type=script&lang=ts&"
export * from "./Reminder2fa.vue?vue&type=script&lang=ts&"
import style0 from "./Reminder2fa.vue?vue&type=style&index=0&id=560e4a55&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports